import { render, staticRenderFns } from "./CostPerRecord.vue?vue&type=template&id=f0629820&"
import script from "./CostPerRecord.vue?vue&type=script&lang=js&"
export * from "./CostPerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports